import {get} from '../utils'
import {includeQuery} from './utils';

export default host => (id, include = includeQuery) =>
  get(`${host}/contentCreations/${id}?${include}`)
    .then(response => response.json())
    .then(json => json.data)
